import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 850px;
  text-align: center;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
`

export const DropContainer = styled.div``

export const Title = styled.h1`
  font-size: 32px;
  font-weight: 700;
  line-height: 32px;
`

export const Description = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  color: ${colors.strongGray};
`

export const Icon = styled.span`
  font-size: 64px;
  color: ${colors.strongGray};
`

export const ButtonContainer = styled.div`
  width: 250px;
  gap: 8px;
  display: flex;
  flex-direction: column;
  margin: auto;
`

export const FilesContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`
export const Ul = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 16px;
  padding: 0 16px 0 0;
`

export const Li = styled.li`
  display: flex;
  width: 100%;
  min-height: 76px;
  border: 1px solid black;
  border: ${(props) => (props.error ? '1px solid #BF4F74' : '1px solid gray')};
  border-radius: 12px;
  list-style-type: none;
  justify-content: space-between;
`

export const LiItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-weight: bold;
  color: ${colors.strongBlack};
  margin-right: 16px;
`

export const Remove = styled.div`
  color: ${colors.strongGray};
  cursor: pointer;
  &:hover {
    color: ${colors.strongRed}
  }
`

export const Header = styled.header`
  display: flex;
  height: 110px;
  gap: 8px;
  align-items: flex-start;
  justify-content: flex-start;
`
